<template>
	<ul v-if="loading" class="list">
		<li :key="i" v-for="(item, i) in items" class="item">
			<el-skeleton style="width: 100%" :loading="loading" animated>
				<template slot="template">
					<el-skeleton-item
						variant="text"
						style="width: 20%; margin-right: 5px; position: absolute; right: 20px; height: 10px"
					/>
					<el-container>
						<el-main style="padding: 0px; width: 40%; margin-top: 25px; margin-bottom: 22px">
							<el-skeleton-item variant="h4" style="width: 60%" />
						</el-main>
					</el-container>
					<el-skeleton-item
						variant="image"
						style="width: 240px; height: 240px; height: 170.66px; width: 100%; border-radius: 4px"
					/>
					<el-container>
						<el-main style="padding: 0px; width: 50%; margin-top: 20px">
							<el-skeleton-item variant="text" style="width: 70%" />
							<el-skeleton-item variant="text" style="width: 50%" />
						</el-main>
					</el-container>
					<el-container>
						<el-main style="padding: 0px; width: 50%; margin-top: 45px; display: inline-flex">
							<el-skeleton-item variant="text" style="width: 30%; height: 30px" />
							<el-skeleton-item variant="text" style="width: 30%; margin-left: 5px; height: 30px" />
						</el-main>
					</el-container>
					<el-container>
						<el-main
							style="
								padding: 0px;
								width: 50%;
								margin-top: 55px;
								display: inline-flex;
								flex-direction: row-reverse;
							"
						>
							<el-skeleton-item variant="text" style="width: 30%" />
							<el-skeleton-item variant="text" style="width: 30%; margin-right: 5px" />
						</el-main>
					</el-container>
				</template>
			</el-skeleton>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		loading: Boolean,
		items: Number,
	},
};
</script>

<style scoped>
.list {
	margin: 0;
	list-style-type: none;
	padding: 2px;
	display: flex;
	align-items: stretch;
	flex-wrap: wrap;
}

.item {
	background-color: white;
	box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
	border-radius: 4px;
	padding: 20px;
	align-items: center;
	margin-bottom: 20px;
	height: 450px !important;
	width: 400px;
	margin-right: 20px;
	position: relative;
}
</style>
